import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/service/user.service';
import { ControlUser } from 'src/app/model/controlUser';
import { FormHelper } from 'src/app/util/formHelper';
import { Log } from '../../util/log';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('loginloader', { static: true }) loader;

  user: ControlUser;
  wrongLogin: boolean;

  constructor(
    private userService: UserService,
    private router: Router,
    private cdRef:ChangeDetectorRef,
    private appComponent: AppComponent) {
  }

  ngOnInit() {
    this.appComponent.logoutSilent();

  }

  login(email: string, password: string) {

    if (!FormHelper.isValidEmail(email)) {
      this.wrongLogin = true;
      return;
    }
    if (!FormHelper.isValidPassword(password)) {
      this.wrongLogin = true;
      return;
    }

    this.wrongLogin = false;

    this.loader.showLoading();

    this.userService.login(email, password).then((user) => {

      Log.debug("user: " + JSON.stringify(user));

      this.userService.getMe().subscribe(user => {

        Log.debug("user: " + JSON.stringify(user));

        this.user = user;

        this.router.navigate(['dashboard']);

      }, errorRes => {

        this.loader.hideLoading();

        this.wrongLogin = true;
        this.cdRef.detectChanges();
        
      });

    }).catch((error) => {

      // Log.debug("error: " + JSON.stringify(error));
      // "auth/wrong-password"
      // "auth/user-not-found"

      this.wrongLogin = true;
      this.loader.hideLoading();
    });
  }

  register() {

    this.router.navigate(['register']);
  }

}
